import { Link } from 'react-router-dom'
import netzence from '../../images/Frame 2147228713.png'
import image1 from '../../images//traffic.png'
import image2 from '../../images/sus2.png'
import image3 from '../../images/Netzence.png'
import Header from '../shared/Header'
import Footer from '../shared/Footer'
import sportlight from '../../images/datawithSS.png'
function BlogPost5() {

     const blogs = [
    {
      id: 1,
      badge: "Sustainable Farming",
      badgeColor: "#006633",
      title: "Netzence partners with Ministry of Livestock, Germany’s GIZ to conduct livestock monitoring capacity-building",
      description: "Netzence Sustainability Limited (Netzence) has taken a significant step toward strengthening Nigeria’s climate accountability and agricultural sustainability framework...",
      source: "06/01/2026",
      image: image1,
      readMoreLink: "#"
    },
    {
      id: 2,
      badge: "Clean Transport",
      badgeColor: "#006633",
      title: "Introducing low-cost mobility for Nigeria’s transport system Netzence",
      description: "Nigeria’s mobility ecosystem is undergoing a profound shift. Rising fuel prices, worsening congestion, and growing urban populations have pushed transportation costs....",
      source: "28/12/2025",
      image: image2,
      readMoreLink: "#"
    },
    {
      id: 3,
      badge: "Methane Monitoring",
      badgeColor: "#00AED9",
      title: "Netzence, Ministry of Livestock Development detect rapid seasonal Methane spikes in livestock systems",
      description: "Nigeria is finally beginning to see what has long remained hidden behind estimates and assumptions:  how livestock methane emissions behave across regions...",
      source: "03/07/2025",
      image: image3,
      readMoreLink: "#"
    }
  ];
  return (
<>

<Header/> 
<Link to="/blogs">
<div className='ml-72 text-[14px] flex pt-20'>
    Return to blog
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.5 18L15.5 12L9.5 6" stroke="#898989" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


</div>
</Link>
<div className='ml-72 text-[24px] font-bold'>2026 Climate Mobility Horizon: Nigeria’s New Income Engine – Netzence</div>
<div className='ml-72 flex gap-5 mt-10 '>
    <img src={netzence} alt="netzence" className='w-[48px]' loading="lazy"></img>


    <div>
        <div className='text-[16px] mb-3'>
            Netzence 
        </div>
        <div className='flex items-center gap-3 '>
            December 28, 2025 <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="3" cy="3" r="3" fill="#898989"/>
</svg>
7 mins read
        </div>
    </div>


</div>
<div className='ml-72 mr-72 mt-20'>
    <img src={sportlight} loading="lazy" alt="spotlight" className='object-fill w-[1200px]'></img>
</div>

 <div className="flex flex-col items-start gap-4 w-full max-w-[1152px] h-auto mt-20 ml-72" >
      {/* Paragraph 1 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
At a time when Nigeria’s cities are expanding at an unprecedented pace, and the strain on urban systems is becoming increasingly visible, a quiet but critical shift is beginning to take shape in how mobility is understood. What was once seen simply as movement from one point to another is now emerging as a defining factor in public health, economic productivity, and environmental sustainability.
</p>
      {/* Paragraph 2 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
It is against this backdrop that Netzence Sustainability Limited (Netzence) has announced the nationwide unveiling of its clean mobility platform, KlimateRide, scheduled for June 2026.</p>

      {/* Paragraph 3 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
The timing is not incidental. According to the World Health Organization, air pollution remains one of the most significant environmental health risks globally, contributing to millions of premature deaths each year. In Nigeria, the burden is particularly acute, with estimates suggesting that over 100,000 premature deaths annually are linked to air pollution exposure. Much of this impact is concentrated in urban areas where transport emissions play a central role in shaping air quality. For children, the consequences are even more profound. UNICEF has consistently warned that exposure to polluted air is associated with respiratory illnesses, impaired lung development, and long-term cognitive effects, making the issue not just environmental but also generational in its implications. </p>

      {/* Paragraph 4 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Despite the scale of the challenge, Nigeria’s transport ecosystem has largely operated without real-time visibility into its environmental footprint. Millions of vehicles move across cities each day, many powered by diesel and other fossil fuels, contributing incrementally but persistently to a cumulative emissions problem. Each journey may appear insignificant in isolation, but together they define the air that millions breathe. What has been missing is not awareness, but systems—systems capable of measuring, managing, and ultimately improving the impact of mobility at scale.</p>

      {/* Paragraph 5 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
It is these system gaps that Netzence, a Nigeria-based climate technology company focused on carbon tracking, clean mobility, and sustainable finance, is seeking to address. With the introduction of KlimateRide, the company is positioning mobility not merely as a service, but as an infrastructure layer—one that integrates safety and environmental accountability directly into everyday transportation. Designed to address enhanced safety needs, urban congestion, and environmental degradation, the platform combines clean energy vehicle adoption, real-time emissions tracking, and a digitally integrated system that prioritises transparency and safety through real-time data analysis and user experience.</p>

      {/* Paragraph 6 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Speaking ahead of the unveiling, the Founder and Chief Executive Officer of Netzence, A/Prof. Sadiq Sani, noted that the challenge Nigeria faces is fundamentally systemic. Mobility, he observed, sits at the intersection of economic activity and environmental impact, and addressing it requires more than incremental improvements. It requires a rethinking of how movement is structured, measured, incentivised, and optimised with the support of Advanced Computer Vision, Artificial Intelligence, Blockchain, Internet of Things, and Quantum Computing. KlimateRide, in this context, is intended not as an addition to existing systems but as a reconfiguration of them.
At the core of the platform is a distributed digital architecture that integrates Internet of Things devices, emissions monitoring and incentive capabilities, AI-driven safety features, low-cost pricing, and secure payment systems through Netzence’s proprietary technologies. This enables, for the first time at scale, the real-time measurement and reporting of vehicle emissions within a ride-hailing environment.    </p>

      {/* Paragraph 7 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
The implications of this are significant. It introduces visibility where there was previously opacity and creates a foundation upon which both users and regulators can make more informed decisions.</p>
      {/* Paragraph 8 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Beyond its technological framework, the platform also responds to the economic realities of Nigeria’s transport sector. Driver earnings, often subject to unpredictability, are addressed through optimisation tools designed to improve income stability, while enhanced safety and verification layers aim to build greater trust for passengers. At the same time, the integration of cleaner energy vehicles, including compressed natural gas and electric options, signals a gradual but necessary transition away from more carbon-intensive fuels that currently dominate commercial transport fleets.</p>

      {/* Paragraph 9 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
For Netzence, the significance of this shift extends beyond immediate operational benefits. As global carbon markets continue to expand, the ability to measure emissions reductions in real time opens new economic pathways. Transport, long considered a diffuse and difficult sector to quantify, becomes a viable contributor to carbon credit generation and climate finance. By embedding emissions tracking into daily mobility, the company is effectively transforming routine transport activity into a source of measurable environmental value, with the potential for monetisation within emerging carbon market frameworks.</p>
      {/* Paragraph 10 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
This convergence of environmental accountability and economic opportunity is central to the company’s broader vision. As articulated by its Chief Technical Officer, Lukas Pfeifle, the goal is to create a system where economic value, environmental responsibility, and user experience are not competing priorities but reinforcing ones. From improved driver livelihoods to better air quality outcomes, the ambition is to deliver impact across the entire mobility value chain.</p>

      {/* Paragraph 11 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Source</p>
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
https://www.vanguardngr.com/2026/03/netzence-set-to-unveil-clean-mobility-hailing-app-in-june-2026/</p>

      {/* Paragraph 12 */}

    </div>

   <div className="items-start gap-10 w-full max-w-[1200px] h-[43px] ml-72">
        <h2 
          className="text-[#0D924F] font-bold text-4xl leading-[43px] w-[225px] h-[43px]"
          style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
        >
          Related Blogs
        </h2>
      </div>

     <div className=" items-start gap-10 w-full max-w-[1201px] h-auto mt-20 ">
      {/* Header */}
   
      {/* Cards Container */}
      <div className="flex flex-row items-stretch gap-8 w-full flex-wrap ml-72 lg:flex-nowrap mb-20">
        {blogs.map((blog) => (
          <div 
            key={blog.id}
            className="flex flex-col items-center pb-6 gap-4 w-[379px] h-[544px] bg-white shadow-[0px_8px_24px_rgba(149,157,165,0.2)] rounded-2xl shrink-0"
          >
            {/* Image */}
            <div className="w-[378px] h-[282px] rounded-t-2xl overflow-hidden">
              <img 
                src={blog.image} 
                alt={blog.title}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>

            {/* Article Content */}
            <div className="flex flex-col items-start gap-4 w-[352px] h-[222px]">
              {/* Badge */}
              <div 
                className="flex flex-row justify-center items-center px-1.5 py-0.5 gap-2 h-[25px] rounded"
                style={{ backgroundColor: blog.badgeColor }}
              >
                <span 
                  className="text-white font-medium text-[14px] leading-[21px]"
                  style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
                >
                  {blog.badge}
                </span>
              </div>

              {/* Text Container */}
              <div className="flex flex-col items-start gap-3 w-full">
                {/* Title */}
                <h3 
                  className="text-[#3B3B3B] font-semibold text-[20px] leading-[24px] tracking-[-0.02em] w-full"
                  style={{ 
                    fontFamily: "'Inter', sans-serif",
                    fontFeatureSettings: "'cv01' on, 'cv03' on, 'cv04' on"
                  }}
                >
                  {blog.title}
                </h3>
                
                {/* Description */}
                <p 
                  className="text-[#898989] font-normal text-[14px] leading-[20px] w-full"
                  style={{ 
                    fontFamily: "'Inter', sans-serif",
                    fontFeatureSettings: "'cv03' on, 'cv04' on"
                  }}
                >
                  {blog.description}
                </p>
              </div>

              {/* Footer */}
              <div className="flex flex-row justify-between items-center w-full">
                <span 
                  className="text-[#3B3B3B] font-normal text-[14px] leading-[21px]"
                  style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
                >
                  {blog.source}
                </span>
                
                <a 
                  href={blog.readMoreLink}
                  className="flex flex-row justify-center items-center gap-2 transition-all duration-150 hover:opacity-80 group"
                >
                  <span 
                    className="text-[#006633] font-medium text-[14px] leading-[20px]"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    Read More
                  </span>
                  <div className="relative w-2.5 h-4 flex items-center justify-center">
                    <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.5 1L6.5 6L1.5 11" stroke="#006633" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
<Footer/>
</>
  )
}

export default BlogPost5